export const message = {
    common: {
        name:"公積金智庫",
        networkError: "網絡錯誤，請檢查網絡！",
        loading: "加載中...",
        loginTimeout: "您長時間未操作，請關閉重新打開！",
        notFound: "抱歉，找不到相關資源！",
        notSupport: "抱歉，無法處理該操作！",
        welcome: "歡迎使用公積金智庫的產品",
        loadingFail: "加載失敗，請點擊重試！",
        optFail: "操作失敗！",
        loginBtn: "登   錄",
        regbtn: "註   冊",
        listNoMore: "没有更多了",
        listError: "請求失敗，點擊重新加載",
        cancelText: "取消",
        confirmText: "確認"
    },
    title: {
        404: "找不到資源",
        403: "訪問受限",
        home: "首頁",
        timeout: "登錄超時",
        login: "登錄",
        entry: "銀聯國際",
        authCallback: "銀聯國際",
        cardWallet: "卡包",
        couponWallet: "券包",
        combinedWallet: "卡券包",
        cardlist: "行業卡列表",
        mall: "積分商城",
        bindCallback: "銀聯國際",
        regCallback: "銀聯國際",
        detail: "詳情",
        bindCard: "綁定會員卡",
        invalidCards: "失效卡",
        memCardDetail: "會員卡詳情",
        invalidCoupons: "失效券",
        couponDetail: "優惠券詳情",
        storeList: "門店列表",
        timelimit: "秒殺活動",
        commodity: "商品詳情",
        clause: "使用條款",
        privacy: "隱私協議"
    }
}